import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { teamApi } from "../lib/events";
import { toast } from "sonner";

const extractError = (e) => e?.response?.data?.detail || "Something went wrong.";

export default function TeamInviteAccept() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setError("Missing invitation token."); return; }
    teamApi.inviteInfo(token)
      .then((d) => { setInfo(d); setName(d.name || ""); })
      .catch((e) => setError(extractError(e)));
  }, [token]);

  const accept = async () => {
    setBusy(true);
    try {
      await teamApi.acceptInvite({ token, name: name || null, password: info.has_account ? null : password });
      toast.success("Invitation accepted — sign in to manage the event.");
      navigate("/login");
    } catch (e) {
      toast.error(extractError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="min-h-screen flex items-center justify-center p-6 bg-[var(--gt-bg)]" data-testid="team-invite-page">
      <div className="gt-card max-w-md w-full">
        <div className="gt-label mb-3">Getickets · Event Team</div>
        {error && <p className="text-sm text-[var(--gt-accent)] font-semibold" data-testid="invite-error">{error}</p>}
        {!error && !info && <p className="text-sm text-[var(--gt-ink-3)]">Loading invitation…</p>}
        {info && (
          <>
            <h1 className="font-heading text-2xl font-black tracking-tighter mb-2">
              You've been invited to help manage
            </h1>
            <p className="text-lg font-bold mb-1" data-testid="invite-event-title">{info.event_title}</p>
            <p className="text-sm text-[var(--gt-ink-2)] mb-5">
              Role: <span className="font-semibold">{info.role_label}</span> · {info.email}
            </p>
            {!info.has_account && (
              <div className="space-y-3 mb-5 text-sm">
                <div>
                  <label className="gt-form-label">Your name</label>
                  <input className="gt-input" value={name} onChange={(e) => setName(e.target.value)} data-testid="invite-name-input" />
                </div>
                <div>
                  <label className="gt-form-label">Create a password (min 8 characters)</label>
                  <input className="gt-input" type="password" value={password}
                    onChange={(e) => setPassword(e.target.value)} data-testid="invite-password-input" />
                </div>
              </div>
            )}
            <button onClick={accept} disabled={busy || (!info.has_account && password.length < 8)}
              className="gt-btn-primary w-full justify-center" data-testid="invite-accept-btn">
              {busy ? <Loader2 size={15} className="animate-spin" /> : null} Accept Invitation
            </button>
          </>
        )}
      </div>
    </section>
  );
}
